import React from "react";

// import dotPattern from "../../Assets/leadership/dot.png";
import vcnrLogo from "../../Assets/vcnr-logo-white.png";

const ArchitectMessage = ({
  image,
  name,
  title,
  paragraphs = [],
  logo = vcnrLogo,
  heading = "Our Architect’s",
  buttonText = "Linkedin Profile",
  buttonLink = "#"
}) => {
  return (
    <section className="founder-section">
      <div className="founder-container">
       
        <div className="founder-right">
          <h3 className="founder-heading">{heading}</h3>
          {logo && <img src={logo} alt="VCNR Logo" className="vcnr-logo" />}
          <h4 className="founder-name">
            {name}
            {title && <><br />{title}</>}
          </h4>
          {paragraphs.map((text, idx) => (
            <p className="founder-text" key={idx}>{text}</p>
          ))}
          {buttonText && (
            <a href={buttonLink} className="explore-btn">{buttonText}</a>
          )}
        </div>

        <div className="founder-left">
          <div className="founder-image-wrapper">
            
            <img src={image} alt={name || "Architect"} className="founder-image" />
            {/* <img src={dotPattern} alt="Dot pattern" className="dot-patternn" /> */}
          </div>
        </div>
      </div>
     
    </section>
  );
};

export default ArchitectMessage; 